var _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaba1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1406 26.6992C54.3875 27.9461 55.3765 29.4263 56.0513 31.0554C56.7261 32.6845 57.0734 34.4305 57.0734 36.1938C57.0734 37.9572 56.7261 39.7032 56.0513 41.3323C55.3765 42.9614 54.3875 44.4416 53.1406 45.6885",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2404 43.652H18.2888C17.8931 43.652 17.5136 43.4948 17.2339 43.215C16.9541 42.9352 16.7969 42.5557 16.7969 42.16V30.2245C16.7969 29.8289 16.9541 29.4494 17.2339 29.1696C17.5136 28.8898 17.8931 28.7326 18.2888 28.7326H27.2404L40.6678 18.2891V54.0955L27.2404 43.652Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2383 28.7305V43.6498",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8633 31.9727C48.4174 32.5268 48.857 33.1847 49.1569 33.9087C49.4568 34.6328 49.6112 35.4088 49.6112 36.1925C49.6112 36.9762 49.4568 37.7522 49.1569 38.4762C48.857 39.2003 48.4174 39.8582 47.8633 40.4123",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.38672,
    y: 1.38672,
    width: 69.6129,
    height: 69.6129,
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaba1);
export default __webpack_public_path__ + "static/media/laba-1.825b96442af8d4eafbe5a7647acc03fb.svg";
export { ForwardRef as ReactComponent };